const routes = {
  createSize: 'size',
  getSizes: 'size',
  getSizeById: 'size/',
  updateSize: 'size/',
  deleteSize: 'size/',
};

export default routes